import { DEFAULT_API_CONFIG } from './apiConfig';
import { createNewUserWithRole } from './account.service';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/user/qa`;

export const getQaUserPermissionsById = async id =>{
    const url = `${baseRoute}/permissions/${id}`;
    let headers = getHeaders();
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
    return response.ok ? await response.json() : Promise.reject(response);
    };

    export const saveQaPermissions = async qap =>{
      const url = `${baseRoute}/permissions`;
      let headers = getHeaders();
      const response = await fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify(qap),
      })
    }